import { RouteObject } from "react-router-dom";
import { DocumentTemplatesList } from "../pages/admin/document-templates/DocumentTemplatesList";
import { DocumentTemplateDetail } from "../pages/admin/document-templates/DocumentTemplateDetail";
import { DocumentTemplateCreate } from "../pages/admin/document-templates/DocumentTemplateCreate";

export const documentTemplatesRoutes: RouteObject[] = [
  {
    id: "document-templates-list",
    index: true,
    element: <DocumentTemplatesList />,
  },
  {
    id: "document-template-detail",
    path: ":id",
    element: <DocumentTemplateDetail />,
  },
  {
    id: "document-template-create",
    path: "create",
    element: <DocumentTemplateCreate />,
  },
];
